
(function () {
  const grid = document.getElementById('journalGrid');
  if (!grid) return;

  const isEs = location.pathname.startsWith('/es/');
  const journalHref = (slug) => (isEs ? `/es/journal/${slug}/` : `/journal/${slug}/`);

  function formatDate(value) {
    if (!value) return '';
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString(isEs ? 'es-ES' : 'en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
  }

  function cardHTML(p) {
    return `
      <a class="work-card" href="${journalHref(p.slug)}" data-slug="${p.slug}">
        <div class="work-card__img-wrap">
          <img src="${p.featured_image}" alt="${p.title}" class="work-card__img" loading="lazy" />
        </div>
        <div class="work-card__meta">
          <p class="work-card__name">${p.title}</p>
          <p class="work-card__subtitle">${p.subtitle || ''}</p>
          <div class="work-card__tags"><span>${formatDate(p.published_at)}</span></div>
        </div>
      </a>`;
  }

  function renderGrid(posts) {
    grid.innerHTML = '';
    grid.removeAttribute('aria-busy');

    if (!posts.length) {
      grid.innerHTML = '<p class="work-grid__error">No posts yet.</p>';
      return;
    }

    let i = 0;
    while (i < posts.length) {
      const full = document.createElement('div');
      full.className = 'work-row work-row--full';
      full.innerHTML = cardHTML(posts[i]);
      grid.appendChild(full);
      i += 1;

      if (i < posts.length) {
        const a = posts[i];
        const b = posts[i + 1];
        const row = document.createElement('div');
        row.className = 'work-row work-row--half' + (b ? '' : ' work-row--orphan');
        row.innerHTML = cardHTML(a) + (b ? cardHTML(b) : '');
        grid.appendChild(row);
        i += b ? 2 : 1;
      }
    }
  }

  fetch(`/api/journal?lang=${isEs ? 'es' : 'en'}`)
    .then(r => r.json())
    .then(renderGrid)
    .catch(err => {
      console.error('No se pudieron cargar los posts del journal:', err);
      grid.removeAttribute('aria-busy');
      grid.innerHTML = '<p class="work-grid__error">No se han podido cargar los posts.</p>';
    });
})();
